
export const CheckoutSentryLogger = ({Sentry}) => ({
    logCheckoutApprovalFailure: ({cartId, result}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout Approval failure",
            level: Sentry.Severity.Error,
            data: {
                cartId,
                result,
            }
        });
        Sentry.captureMessage("Checkout Approval failure", Sentry.Severity.Error);
    },

    logCheckoutApprovalSuccess: ({cartId}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout Approval success",
            level: Sentry.Severity.Log,
            data: {
                cartId,
            }
        });
        Sentry.captureMessage("Checkout Approval success", Sentry.Severity.Log);
    },

    logCheckoutSubmitForApprovalFailure: ({cartId, result}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout Submit For Approval failure",
            level: Sentry.Severity.Error,
            data: {
                cartId,
                result,
            }
        });
        Sentry.captureMessage("Checkout Submit For Approval failure", Sentry.Severity.Error);
    },

    logCheckoutSubmitForApprovalSuccess: ({cartId}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout Submit For Approval success",
            level: Sentry.Severity.Log,
            data: {
                cartId,
            }
        });
        Sentry.captureMessage("Checkout Submit For Approval success", Sentry.Severity.Log);
    },

    logCheckoutFailure: ({cartId, result}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout failure",
            level: Sentry.Severity.Error,
            data: {
                cartId,
                result,
            }
        });
        Sentry.captureMessage("Checkout failure", Sentry.Severity.Error);
    },

    logCheckoutSuccess: ({cartId}) => {
        Sentry.addBreadcrumb({
            category: "checkout",
            message: "Checkout success",
            level: Sentry.Severity.Log,
            data: {
                cartId,
            }
        });
        Sentry.captureMessage("Checkout success", Sentry.Severity.Log);
    },
});









